module.exports = __webpack_public_path__ + "img/btn-google@2x.1227858a.png";